import $ from 'jquery';
import EventEmitter from 'events';
import Class from './EventsListViewClasses';
import { loadDatePicker } from '../Loaders';
import { getISODateString, startOfDay, endOfDay } from '../date/DateHelpers';
import DateFormatter from '../date/EventListingDateFormatter';

class EventListControls extends EventEmitter {
  constructor({
    hideListViewControls,
    earliestEventDate,
    latestEventDate,
    defaultDisplayDate,
    label,
    listingStartDate,
    listingEndDate,
  }) {
    super();
    this.minDate = earliestEventDate;
    this.maxDate = latestEventDate;

    this.dateFrom = listingStartDate;
    this.dateTo = listingEndDate;

    this.initialDateFrom = this.dateFrom;
    this.initialDateTo = this.dateTo;

    if (hideListViewControls) {
      return;
    }

    const html = $('#tn-events-list-view-controls-template').html();
    this.$el = $(html);

    this.$btnReset = this.$el.find(`.${Class.BTN_RESET}`);
    this.$btnReset.on('click', this.resetDates.bind(this));

    this.init(label.listView);
  }

  async init({ inputDateTo, inputDateFrom }) {
    const DatePicker = await loadDatePicker();
    const {
      dateFrom,
      dateTo,
      minDate,
      maxDate,
    } = this;

    this.onDateChanged = this.onDateChanged.bind(this);

    this.datePickerFrom = new DatePicker({
      minDate,
      maxDate,
      date: dateFrom,
      label: inputDateFrom,
      dateFormatter: DateFormatter.standardDate,
      hideLabel: true,
      id: 'tn-event-list-input-date-from',
      container: this.$el.find(`.${Class.INPUT_CONTAINER_FROM}`),
      onChange: (date) => {
        this.dateFrom = date;
        this.onDateChanged();
      },
    });

    this.datePickerTo = new DatePicker({
      minDate: dateFrom,
      maxDate,
      date: dateTo,
      label: inputDateTo,
      dateFormatter: DateFormatter.standardDate,
      hideLabel: true,
      id: 'tn-event-list-input-date-to',
      container: this.$el.find(`.${Class.INPUT_CONTAINER_TO}`),
      onChange: (date) => {
        this.dateTo = date;
        this.onDateChanged();
      },
    });
  }

  resetDates() {
    this.dateFrom = this.initialDateFrom;
    this.dateTo = this.initialDateTo;

    this.datePickerFrom.setDates({
      date: this.dateFrom,
      minDate: this.minDate,
      maxDate: this.maxDate,
    });

    this.datePickerTo.setDates({
      date: this.dateTo,
      minDate: this.dateFrom,
      maxDate: this.maxDate,
    });

    this.onDateChanged();
  }

  onDateChanged() {
    const { dateFrom, dateTo } = this;

    this.datePickerFrom.setMaxDate(dateTo);
    this.datePickerTo.setMinDate(dateFrom);

    this.updateBtnReset();

    this.dispatchUpdate();
  }

  updateBtnReset() {
    const { dateFrom, dateTo } = this;
    let dateHasChanged = false;

    if (!this.initialDateFromString) {
      this.initialDateFromString = getISODateString(this.initialDateFrom);
      this.initialDateToString = getISODateString(this.initialDateTo);
    }

    if (
      getISODateString(dateFrom) !== this.initialDateFromString ||
      getISODateString(dateTo) !== this.initialDateToString
    ) {
      dateHasChanged = true;
    }

    this.$btnReset.prop('disabled', dateHasChanged === false);
  }

  dispatchUpdate() {
    this.emit(EventListControls.UPDATE);
  }

  getSearchDateRange() {
    const { dateFrom, dateTo } = this;

    return {
      startDate: startOfDay(dateFrom),
      endDate: endOfDay(dateTo),
    };
  }

}

EventListControls.UPDATE = 'tnEventListControls:update';

export default EventListControls;



// WEBPACK FOOTER //
// ./V7/events/listing/listView/EventsListControls.js